import { useState } from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import UpdateVersion from "./components/UpdateVersion";
import MainPage from "./pages/MainPage";
import "react-toastify/dist/ReactToastify.css";

import { baseURL } from "./env";
import axios from "axios";

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

const fadeTransition = cssTransition({
  enter: "animate__animated animate__fadeInUp",
  exit: "animate__animated animate__fadeOutDown"
});

function App() {
  const [showUpdateVersion, setShowUpdateVersion] = useState(false);
  window.setShowUpdateVersion = setShowUpdateVersion;

  return (
    <>
      <ToastContainer
        limit={1}
        className="w-full"
        position="bottom-center"
        autoClose={1500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        transition={fadeTransition}
      />
      {showUpdateVersion && (
        <UpdateVersion setShowUpdateVersion={setShowUpdateVersion} />
      )}
      <MainPage />
    </>
  );
}

export default App;
